// Алфавит и длина кода внешнего экрана зафиксированы контрактом
// docs/TV_SCREEN_CONTRACT.md. Матч этим ограничениям на входе — на бэке та же проверка.
export const SCREEN_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const SCREEN_CODE_LENGTH = 6;
/**
 * Нормализует код экрана, введённый вручную или полученный из QR:
 * убирает любые разделители и приводит к верхнему регистру.
 */
export const normalizeScreenCode = (raw) => raw.replace(/[\s\-_]+/g, '').toUpperCase();
/**
 * Отрисовка кода в формате XXX-XXX. Для коротких строк разделитель
 * ставим после трёх символов, чтобы ведущему было проще сверить ввод.
 */
export const formatScreenCode = (code) => {
    const normalized = normalizeScreenCode(code);
    if (normalized.length <= 3)
        return normalized;
    return `${normalized.slice(0, 3)}-${normalized.slice(3, SCREEN_CODE_LENGTH)}`;
};
/**
 * Проверка, что код полный и использует только разрешённые символы.
 * Делается до запроса, чтобы не ловить 422 ради печаток ведущего.
 */
export const isValidScreenCode = (raw) => {
    const normalized = normalizeScreenCode(raw);
    if (normalized.length !== SCREEN_CODE_LENGTH)
        return false;
    for (const ch of normalized) {
        if (!SCREEN_CODE_ALPHABET.includes(ch))
            return false;
    }
    return true;
};
/**
 * Из QR экрана может прийти чистый код, URL с кодом в query (?code=...)
 * или путь /screen/XXXXXX. Берём первое, что укладывается в алфавит.
 */
export const extractScreenCodeFromQr = (payload) => {
    var _a;
    const trimmed = payload.trim();
    if (!trimmed)
        return null;
    // 1) чистый код
    if (isValidScreenCode(trimmed))
        return normalizeScreenCode(trimmed);
    // 2) URL с ?code=...
    try {
        const url = new URL(trimmed);
        const codeParam = url.searchParams.get('code');
        if (codeParam && isValidScreenCode(codeParam)) {
            return normalizeScreenCode(codeParam);
        }
        const pathCandidate = (_a = url.pathname.split('/').filter(Boolean).pop()) !== null && _a !== void 0 ? _a : '';
        if (isValidScreenCode(pathCandidate))
            return normalizeScreenCode(pathCandidate);
    }
    catch (_b) {
        // не URL — продолжаем
    }
    // 3) попытка нормализовать подстроку, если скан прилип к чему-то ещё
    const normalized = normalizeScreenCode(trimmed);
    const match = normalized.match(new RegExp(`[${SCREEN_CODE_ALPHABET}]{${SCREEN_CODE_LENGTH}}`));
    if (match)
        return match[0];
    return null;
};
